import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { useLocation } from 'react-router-dom';

interface PageEnterProps {
  children: ReactNode;
}

/** Soft fade-up for route content — re-plays on pathname change. */
export function PageEnter({ children }: PageEnterProps): JSX.Element {
  const { pathname } = useLocation();

  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.17, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
